<script>
import wx from "weixin-js-sdk";
import { Dialog } from 'vant';
import Temp from '@/components/technician/temp/index'
import SiteInfoModal from "@/components/lottery/updateSiteInfo/index.vue";
import UserInfoModal from "@/components/lottery/updateUserInfo/index.vue";
// import AddInfoModal from "@/components/lottery/addUserInfo/index.vue";
import AddBankModal from "@/components/lottery/addBankInfo/index.vue";
// import UpdateImgModal from "@/components/lottery/uploadImg/index.vue";
import {
  branchInfoList,
  changePhoneNumber,
  logoutRequest,
  processFlowinit,
  processFlowlist,
  processRemove,
  salespersonInfoList,
  updateAgentInfo,
  updateBranchInfo,
  updateSalespersonInfo
} from "@/lib/request";
import {delLocalItem, getLocalItem} from "@/untils/common";
import { ClientId } from "@/lib/cli"
export default {
  name:'stationInfo',
  components: {
    Temp,
    SiteInfoModal,
    UserInfoModal,
    // AddInfoModal,
    AddBankModal,
    // UpdateImgModal,
    [Dialog.Component.name]: Dialog.Component,
  },
  data(){
    return{
      flagTemplate:false,
      // showRetryDialog: false,
      //------
      fileVideoUrl:'/api/resource/oss/upload',//接口前缀加api
      headers:{
        'isEncrypt':true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid' : ClientId,
      },
      loading:false,
      imgFlag2: false,
      //是否显示进度条
      imgUploadPercent2: 0,
      //进度条的进度，
      isShowUploadImg2: false,
      //显示上传按钮
      imgForm2: {
        showVideoPath: "",  //回显的变量
      },
      longitude:'',//108.390062 本地调试使用
      latitude:'',//22.818713 本地调试使用




      imgFlag1: false,
      //是否显示进度条
      imgUploadPercent1: 0,
      //进度条的进度，
      isShowUploadImg1: false,
      //显示上传按钮
      imgForm1: {
        showVideoPath: "",  //回显的变量
      },

      imgFlag3: false,
      //是否显示进度条
      imgUploadPercent3: 0,
      //进度条的进度，
      isShowUploadImg3: false,
      //显示上传按钮
      imgForm3: {
        showVideoPath: "",  //回显的变量
      },

      // -------
      salesObj:{},
      roleName:'',
      chockFlag:false,
      siteId:'',
      activeTab:0,
      showSiteInfo:false,
      listSite:[],
      // 销售员信息
      salespersonInfos:[
        // {
        //   "createDept": 103,
        //   "createBy": 1,
        //   "createTime": "2025-04-24 16:13:46",
        //   "updateBy": 1,
        //   "updateTime": "2025-04-24 16:13:46",
        //   "userId": "1916425145625423874",
        //   "city": "西藏自治区/拉萨市",
        //   "name": "拉销测",
        //   "gender": "0",
        //   "contact": "13212344321",
        //   "jobCertificate": null,
        //   "registrationDate": null,
        //   "deptId": 103,
        //   "reviewStatus": 0,//0待审核，1审核成功，2审核失败，3删除
        // },
      ],
      // 代销者信息
      agentInfo:{
        // "createDept": '',
        // "createBy": '',
        // "createTime": "",
        // "updateBy": '',
        // "updateTime": "",
        // "userId": "",
        // "city": "",
        // "agentName": "",
        // "gender": "",
        // "contact": "",
        // "idCard": "",
        // "deptId": '',
        // "bankName": null,
        // "bankBranch": null,
        // "bankCardNumber": null,
        // "branchInfo": null
        // "createDept": 103,
        // "createBy": 1,
        // "createTime": "2025-04-24 16:13:46",
        // "updateBy": 1,
        // "updateTime": "2025-04-24 16:13:46",
        // "userId": "1915318230648389633",
        // "city": "西藏自治区/拉萨市",
        // "agentName": "王淑珍",
        // "gender": "1",
        // "contact": "15872818202",
        // "idCard": "42232619820916584X",
        // "deptId": 103,
        // "bankName": null,
        // "bankBranch": null,
        // "bankCardNumber": null,
        // "branchInfo": null
      },
      // 网点信息
      siteItem:{
        // "branchId": '',
        // "businessType": "",
        // "businessStatus": "",
        // "closureReason": null,
        // "branchType": "",
        // "branchLevel": "",
        // "city": "",
        // "address": "",
        // "storefrontPhoto": null,
        // "updateTime": "",
        // "deptId": '',
        // "companyName": null,
        // "taxpayerId": null,
        // "agentCertificate": null,
        // "registrationDate": null,
        // "registrationType": null
        // "branchId": 54010001,
        // "businessType": "1",
        // "businessStatus": "1",
        // "closureReason": null,
        // "branchType": "1",
        // "branchLevel": "三级",
        // "city": "西藏自治区/拉萨市",
        // "address": "拉萨市纳金路路北居委会3组3号",
        // "storefrontPhoto": null,
        // "updateTime": "2025-04-24 16:13:46",
        // "deptId": 103,
        // "companyName": null,
        // "taxpayerId": null,
        // "agentCertificate": null,
        // "registrationDate": null,
        // "registrationType": null
      },
      // 开户行信
      showUserInfo:false,
      // showAddInfo:false,
      showBankInfo:false,
      showImgInfo:false,
      showImageInfo:false,
      showCertImageInfo:false,
      categoryStr:'',
      listPramsObj:[
        // {
        //   "msgs": [
        //     {
        //       "category": "西藏-多租户",
        //       "version": "2",
        //       "processDefinitionId": "wd-jylxbg:2:f9a12629-450b-11f0-b32c-3606515d593d",
        //       "processDefinitionName": "网点-经营类型变更",
        //       "arr_name": "经营类型变更"
        //     },
        //     {
        //       "category": "西藏-多租户",
        //       "version": "3",
        //       "processDefinitionId": "wd-xxgz:3:f9a12624-450b-11f0-b32c-3606515d593d",
        //       "processDefinitionName": "网点-信息更正",
        //       "arr_name": "信息更正"
        //     }
        //   ],
        //   "category": "西藏-多租户"
        // }
      ],
      returnObj:{},
      formDefine:{},
      formFields:[],
      flagTemp:false,
      siteIdObj:{},
      flowNameObj:{},
      removeListener: null,
      osIng:''
    }
  },
  beforeDestroy() {
    if (this.removeListener) {
      this.removeListener()
    }
  },
  methods:{
    showConfirmModal() {
      this.getApiDel();
    },
    getApiDel() {
      if(this.returnObj.processInstanceId){
        processRemove({
          processInstanceId: this.returnObj.processInstanceId
        }).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                console.log(res.data)
                this.flagTemp = false;
              } else {
                this.$toast(res.data.msg);
                return false;
              }
            }
          }
        });
      }
    },
    detectOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Windows Phone 必须优先检测
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }

      // 接下来是Android
      if (/android|Android/i.test(userAgent)) {
        return "Android";
      }

      // iOS检测
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      // 检测是否为华为设备
      if(/huawei/i.test(navigator.userAgent) || /honor/i.test(navigator.userAgent)){
        return "huawei";
      }
      // 其他情况，如Mac OS、Windows等
      return "Unknown";
    },
    initWechatBackListener() {
      // 检测是否在微信环境中
      const isWechat = /micromessenger/i.test(navigator.userAgent.toLowerCase())

      if (isWechat) {
        // 添加历史记录
        window.history.pushState({ page: 'stationInfo' }, '', document.URL)

        // 定义处理函数
        const handleBack = (event) => {
          event.preventDefault()
          this.showConfirmModal()
        }

        // 添加事件监听
        window.addEventListener('popstate', handleBack, false)

        // 保存移除函数
        this.removeListener = () => {
          window.removeEventListener('popstate', handleBack, false)
        }
      }
    },
    getWechatLocation(){
      let that = this;
      // let url = window.location.href.split('#')[0];
      // if(url) {
      //   // 接口返回appid和签名类的数据
      //   this.$http.weChatScan_preScan({
      //     url:url,
      //   }).then((res) => {
      //     if (res&&res.data) {
      //       // console.log('第二步：验证签名接口返回数据，进入wx.config执行');
      //       wx.config({
      //         debug: false, // 开启调试模式,
      //         appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
      //         timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      //         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      //         signature: res.data.signature,// 必填，签名，见附录1
      //         jsApiList: [
      //           'getLocation',
      //           // 'chooseImage',
      //           // 'scanQRCode',
      //           // 'getLocalImgData',
      //           // 'openCustomerServiceChat',
      //           // 'updateAppMessageShareData',
      //           // 'updateTimelineShareData', // 需要使用的JSAPI列表
      //           // 'onMenuShareTimeline', // 旧版朋友圈分享（兼容）
      //           // 'onMenuShareAppMessage' // 旧版好友分享（兼容）
      //         ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      //       });
      //       wx.ready(() => {
      //         console.log('ready--------')
              wx.getLocation({
                type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入' gcj02 '
                success: function (data) {
                  console.log(data);
                  that.latitude = data.latitude;
                  that.longitude = data.longitude;
                },
                fail: err => {
                  that.getConfig();
                  console.log('wx.getLocation方法 ，失败');
                  console.log(err);
                  console.log(err.errMsg);
                  if (err.errMsg.includes('user deny')) {
                    that.$toast = '您拒绝了位置授权，请前往设置开启';
                  } else {
                    that.$toast = `获取位置失败：${err.errMsg}`;
                  }
                }
              });
        //     });
        //     wx.error(error => {
        //       // this.$toast.fail('验证签名失败，无法获得微信分享功能')
        //       console.log('---wx.config---SDK初始化失败------');
        //       console.log(error)
        //       console.log(error.errMsg)
        //       Dialog.alert({
        //         title: '获取地理位置失败',
        //         message: `
        //         <div class="innerDialog">
        //           <div style="text-align: left;">点击刷新按钮，再次操作上传门头照片功能，系统会给您授权地理位置的提示，请您务必选择允许按钮。</div>
        //         </div>`,
        //         confirmButtonText: '刷新',
        //         theme: 'round-button',
        //       }).then(() => {
        //         // 刷新页面
        //         location.reload();
        //       });
        //     });
        //   }else{
        //     that.$toast('请求出错！')
        //   }
        // });
      // }
    },

    getConfig(){
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,//encodeURIComponent(url),
        }).then((res) => {
          if (res) {
            if (res.code && res.code === 200) {
              wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: [
                  'getLocation',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
              wx.ready(() => {
                this.getWechatLocation();
              });
              wx.error(error => {
                console.error('---wx.config---SDK初始化失败------');
                console.error(error)
                console.error(error.errMsg)
              });
            }
          }
        });
      }
    },


    // getLocation() {
    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(
    //         this.getPositionSuccess,
    //         this.getPositionError,
    //         {
    //           enableHighAccuracy: true,
    //           timeout: 5000,
    //           maximumAge: 0
    //         }
    //     );
    //   } else {
    //     this.$toast("您的浏览器不支持地理位置功能");
    //   }
    // },
    //
    // getPositionSuccess(position) {
    //   this.latitude = position.coords.latitude;
    //   this.longitude = position.coords.longitude;
    //
    // },
    //
    // getPositionError(error) {
    //   console.log(error)
    //   console.log(error.code)
    //
    //   this.showImgInfo = false;
    //   switch(error.code) {
    //     case error.PERMISSION_DENIED:
    //       console.log('用户拒绝了地理位置请求')
    //       Dialog.alert({
    //         title: '请开启位置权限',
    //         message: `
    //       <div class="innerDialog">
    //         <div style="font-weight: bold">安卓系统：</div>
    //         <div style="">进入手机“设置”-“应用管理”-“微信”。</div>
    //         <div style="">点击“权限”，找到“位置信息”选项。</div>
    //         <div style="">选择“允许”或“仅使用时允许”。</div>
    //         <div style="font-weight: bold">iOS系统：</div>
    //         <div style="">进入手机“设置”-“隐私”-“定位服务”。</div>
    //         <div style="">找到“微信”应用，选择“使用App期间”或“始终”。</div>
    //         <div style=""></div>
    //       </div>`,
    //         theme: 'round-button',
    //       }).then(() => {
    //         // on close
    //         console.log('9999991111111')
    //       });
    //       this.$toast("用户拒绝了地理位置请求");
    //       break;
    //     case error.POSITION_UNAVAILABLE:
    //       this.$toast("位置信息不可用");
    //       break;
    //     case error.TIMEOUT:
    //       this.$toast("获取位置请求超时");
    //       break;
    //     case error.UNKNOWN_ERROR:
    //       this.$toast("发生未知错误");
    //       break;
    //   }
    // },
    // retryGetLocation() {
    //   this.showRetryDialog = false;
    //   this.getLocation();
    // },



    // requestGeolocation() {
    //   console.log('11111111111')
    //   // 1. 检查是否支持
    //   if (!navigator.geolocation) {
    //     alert('您的设备不支持地理位置功能');
    //     return;
    //   }
    //
    //   // 2. 检查当前权限状态
    //   navigator.permissions.query({name: 'geolocation'}).then(result => {
    //     console.log(result)
    //     console.log(result.state)
    //     if (result.state === 'granted') {
    //       // 已有权限，直接获取位置
    //       this.getPosition();
    //     } else if (result.state === 'prompt') {
    //       // iOS 需要用户交互才能显示弹窗
    //       this.showPermissionButton();
    //     } else if (result.state === 'denied') {
    //       // 引导用户去设置中开启
    //       this.showSettingsGuide();
    //     }
    //
    //     // 监听权限变化
    //     result.onchange = () => {
    //       if (result.state === 'granted') {
    //         this.getPosition();
    //       }
    //     };
    //   }).catch(() => {
    //     // 某些iOS版本可能不支持permissions API
    //     this.getPosition();
    //   });
    // },
    //
    // // 显示需要用户点击的按钮
    // showPermissionButton() {
    //   this.showRetryDialog = true;
    // },
    //
    // // 实际获取位置
    // getPosition() {
    //   console.log('1111222223333')
    //   navigator.geolocation.getCurrentPosition(
    //       position => {
    //         console.log('位置获取成功:', position);
    //         // 处理位置数据...
    //
    //         this.latitude = position.coords.latitude;
    //         this.longitude = position.coords.longitude;
    //       },
    //       err => {
    //         console.error('获取位置失败:', err.message);
    //         if (err.code === err.PERMISSION_DENIED) {
    //           this.showSettingsGuide();
    //         }
    //       },
    //       {
    //         enableHighAccuracy: true,
    //         timeout: 15000,
    //         maximumAge: 0
    //       }
    //   );
    // },
    //
    // // 显示前往设置的指引
    // showSettingsGuide() {
    //   // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    //   Dialog.alert({
    //     title: '请开启位置权限',
    //     message: `
    //       <div class="innerDialog">
    //         <div style="font-weight: bold">安卓系统：</div>
    //         <div style="">进入手机“设置”-“应用管理”-“微信”。</div>
    //         <div style="">点击“权限”，找到“位置信息”选项。</div>
    //         <div style="">选择“允许”或“仅使用时允许”。</div>
    //         <div style="font-weight: bold">iOS系统：</div>
    //         <div style="">进入手机“设置”-“隐私”-“定位服务”。</div>
    //         <div style="">找到“微信”应用，选择“使用App期间”或“始终”。</div>
    //         <div style=""></div>
    //       </div>`,
    //     theme: 'round-button',
    //   }).then(() => {
    //     // on close
    //     console.log('9999991111111')
    //   });
    //   // const guide = document.createElement('div');
    //   // guide.innerHTML = `
    //   //   <p>您已拒绝地理位置权限</p>
    //   //   <p>请前往: ${isIOS ? '设置 > 隐私 > 定位服务' : '浏览器设置'} 中开启权限</p>
    //   // `;
    //   // document.body.appendChild(guide);
    // },



    // 彩票照
    // 上传照片 oss
    beforeUploadImg1(file) {
      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg1 = false;
      this.imgForm1.showVideoPath = URL.createObjectURL(file);
    },
    //进度条
    uploadImgProcess1(event, file, fileList) {    //注意在data中添加对应的变量名
      console.log('彩票照',event)
      console.log('彩票照',fileList)
      this.imgFlag1 = true;
      this.imgUploadPercent1 = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleImgSuccess1(res, file) {
      console.log('彩票照',file)
      this.loading = true;
      this.isShowUploadImg1 = true;
      this.imgFlag1 = false;
      this.imgUploadPercent1 = 0;
      //后台上传数据
      if (res.code === 200) {
        if(res.data){
          this.loading = false;
          // 彩票照参数
          this.siteItem.ticketPhoto = res.data.ossId;
        }
      } else {
        this.$toast(res.msg);
        return false;
      }
    },
    beforeDelete( index) {
      if(index===1){
        this.imgForm1 = {}
        this.imgForm1.showVideoPath = ''
      }else if(index===2){
        this.imgForm2 = {}
        this.imgForm2.showVideoPath = ''
      }else if(index===3){
        this.imgForm3 = {}
        this.imgForm3.showVideoPath = ''
      }
    },

    // 门 头照
    // 上传照片 oss
    beforeUploadImg2(file) {
      // 微信授权 获取地理位置
      this.getWechatLocation();

      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg2 = false;
      this.imgForm2.showVideoPath = URL.createObjectURL(file);
    },
    //进度条
    uploadImgProcess2(event, file, fileList) {    //注意在data中添加对应的变量名
      console.log('门头照',event)
      console.log('门头照',fileList)
      this.imgFlag2 = true;
      this.imgUploadPercent2 = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleImgSuccess2(res, file) {
      console.log('门头照',file)
      this.loading = true;
      this.isShowUploadImg2 = true;
      this.imgFlag2 = false;
      this.imgUploadPercent2 = 0;
      //后台上传数据
      if (res.code === 200) {
        if(res.data){
          this.loading = false;
          // 门 头照参数
          this.siteItem.storefrontPhoto = res.data.ossId;
        }
      } else {
        this.$toast(res.msg);
        return false;
      }
    },
    // 代销证照片

    // 上传照片 oss
    beforeUploadImg3(file) {
      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg3 = false;
      this.imgForm3.showVideoPath = URL.createObjectURL(file);
    },
    //进度条
    uploadImgProcess3(event, file, fileList) {    //注意在data中添加对应的变量名
      console.log('代销证照',event)
      console.log('代销证照',fileList)
      this.imgFlag3 = true;
      this.imgUploadPercent3 = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleImgSuccess3(res, file) {
      console.log('代销证照',file)
      this.loading = true;
      this.isShowUploadImg3 = true;
      this.imgFlag3 = false;
      this.imgUploadPercent3 = 0;
      //后台上传数据
      if (res.code === 200) {
        if(res.data){
          this.loading = false;
          // 代销证参数
          this.siteItem.agentCertificate = res.data.ossId;
        }
      } else {
        this.$toast(res.msg);
        return false;
      }
    },



    // getLocationSignIn () {
    //   // 本地使用，静态参数
    //   // this.siteItem.longitude = this.longitude;
    //   // this.siteItem.latitude = this.latitude;
    //
    //   // 正确的实现方式
    //   if ("geolocation" in navigator) {
    //     navigator.geolocation.getCurrentPosition(
    //         (position) => {
    //           console.log("位置获取成功:", position.coords);
    //             if(position.coords.latitude&&position.coords.longitude){
    //               this.longitude = position.coords.longitude;
    //               this.latitude = position.coords.latitude;
    //             }
    //         },
    //         (error) => {
    //           console.error("获取位置失败:", error.message);
    //           this.$toast(error.message);
    //           // 错误代码可能是PERMISSION_DENIED
    //         },
    //         {
    //           enableHighAccuracy: true,
    //           timeout: 5000,
    //           maximumAge: 0
    //         }
    //     );
    //   } else {
    //     this.$toast("浏览器不支持地理位置功能");
    //   }
    //
    //
    //   //---------------------------------------
    //   // 域名下使用，用户同意获取地理位置，活动参数
    //   // const _this = this;
    //   // _this.loading = true;
    //   // ---------------------------------------
    //   // // 生产环境代码-需要https h5方法获取浏览器经纬度
    //   // navigator.geolocation.getCurrentPosition((res) => {
    //   //   console.log(res);
    //   //   if(res.coords.latitude&&res.coords.longitude){
    //   //     _this.siteItem.longitude = res.coords.longitude;
    //   //     _this.siteItem.latitude = res.coords.latitude;
    //   //   }
    //   // },(err) => {
    //   //   console.log('获取位置失败！', err)
    //   //   setTimeout(()=>{
    //   //     _this.loading = false;
    //   //     console.log('定位失败错误：', err);
    //   //     _this.$toast(err.message);
    //   //   },2000)
    //   //   return false;
    //   // },{
    //   //   enableHighAccuracy: true, // 位置是否精确获取
    //   //   timeout: 5000, //获取位置允许的最长时间
    //   //   maximumAge: 1000 // 多久更新获取一次位置
    //   // });
    //   // ---------------------------------------
    // },

    // 销售员的信息接口
    saleInfo(){
      salespersonInfoList({}).then((res)=>{
        if(res){
          console.log(res)
          console.log(res.data)
          console.log(res.rows)
          console.log(res.code)
          if(res.data){
            this.chockFlag = true;
            if(res.data.rows.length>0){
              // 代销者信息
              if(res.data.rows[0].branchInfo){
                this.agentInfo = res.data.rows[0].branchInfo;
                this.siteItem = res.data.rows[0].branchInfo;
              }
              // 销售员
              this.salesObj = res.data.rows[0];
            }
          }
        }
      })
    },
    // 网点信息和代销者信息以及销售员列表信息
    getSiteUserInfo(){
      branchInfoList({
        pageNum:1,
        pageSize:10,
        branchId:this.siteId
      }).then((res)=>{
        if(res){
          if(res.data.code===200) {
            this.chockFlag = true;
            if(res.data.rows[0]&&res.data.rows[0].agentInfo){
              // 代销者信息
              this.agentInfo = res.data.rows[0].agentInfo;
            }
            if(res.data.rows[0]&&res.data.rows[0].salespersonInfos) {
              // 销售员信息
              let arr = [];
              res.data.rows[0].salespersonInfos.map((v)=>{
                if(v.userId){
                  arr.push(v);
                }
              });
              this.salespersonInfos = arr;
              // this.salesObj = res.data.rows[0].salespersonInfos[0];
            }
            if(res.data.rows[0]){
              let newObj = { ...res.data.rows[0] };
              delete newObj.agentInfo;
              delete newObj.salespersonInfos;
              // 网点信息
              this.siteItem = newObj;
              if(newObj.storefrontPhotoUrl){
                this.imgForm2.showVideoPath = newObj.storefrontPhotoUrl;
              }
              if(newObj.ticketPhotoUrl){
                this.imgForm1.showVideoPath = newObj.ticketPhotoUrl;
              }
              if(newObj.agentCertificateUrl){
                this.imgForm3.showVideoPath = newObj.agentCertificateUrl;
              }
              //
            }
          }else{
            this.$toast.fail(res.data.msg)
          }
        }
      })
    },

    // 删除销售员信息
    confirmDeleteStaff(item,type){
      Dialog.confirm({
        title: '',
        message: `确定要删除销售员"${item.name}"吗？`,
      }).then(() => {
        // on confirm
        item.branchId = this.siteId;
        item.reviewStatus = type;
        updateSalespersonInfo(item).then((res)=>{
          if(res){
            if(res.data.code===200){
              this.getSiteUserInfo();
              this.$toast.success(res.data.msg);
            }else{
              this.$toast.fail(res.data.msg)
            }
          }
        })
      }).catch(() => {
        // on cancel
        console.log('222')
      });
    },
    // 审核销售员信息
    getStaff(item,type){
      Dialog.confirm({
        title: '',
        message: `确定要${type===1?'通过':'拒绝'}销售员"${item.name}"的申请吗？`,
      }).then(() => {
        // 对接后台提供的接口
        // on confirm
        item.branchId = this.siteId;
        item.reviewStatus = type;
        updateSalespersonInfo(item).then((res)=>{
          if(res){
            if(res.data.code===200){
              this.getSiteUserInfo();
              this.$toast.success(res.data.msg);
            }else{
              this.$toast.fail(res.data.msg)
            }
          }
        })
      }).catch(() => {
        // on cancel
        console.log('22211111111')
      });

    },
    //网点营业状态
    handleSiteInfoSubmit(data){
      updateBranchInfo(data).then((res)=>{
        if(res){
          if(res.data.code===200) {
            this.getSiteUserInfo();
            this.showSiteInfo = false;
            this.$toast.success(res.data.msg);
          }else{
            this.$toast.fail(res.data.msg);
          }
        }
      })
    },
    // 代销者修改手机号信息
    handleUserInfoSubmit(data){
      changePhoneNumber(data).then((res)=>{
        if(res){
          if(res.data.code===200){
            this.showUserInfo = false;
            setTimeout(()=>{
              this.logout();
            },2000)
            delLocalItem('access_token');
            this.$toast.success(`${res.data.msg}，即将退出，进入登录页面，请重新登录`);
          }else{
            this.$toast.fail(res.data.msg);
          }
        }
      })
      // this.$toast.success('修改成功！');
    },
    logout(){
      logoutRequest().then((res)=>{
        if(res){
          if(res.data.code===200){
            if(getLocalItem('open_id')){
              delLocalItem('local_role')
              this.$router.push({path: '/login',query:{openid: getLocalItem('open_id')}})
            }
          }else{
            this.$toast.fail(res.data.msg);
          }
        }
      })

    },
    // handleAddUserInfoSubmit(data){
    //   console.log(data)
    //   this.$toast.success('修改成功！');
    // },
    // 银行账户信息
    handleAddBackInfoSubmit(data){
      updateAgentInfo(data).then((res)=>{
        if(res){
          if(res.data.code===200) {
            this.getSiteUserInfo();
            this.showBankInfo = false;
            this.$toast.success(res.data.msg);
          }else{
            this.$toast.fail(res.data.msg);
          }
        }
      })
    },
    // 彩票照
    handleUpdateImageSubmit(){
      updateBranchInfo(this.siteItem).then((res)=>{
        if(res){
          if(res.data.code===200) {
            this.showImageInfo = false;
            this.getSiteUserInfo();
            this.$toast.success(res.data.msg);
          }else{
            this.$toast.fail(res.data.msg);
          }
        }
      });
    },
    // 彩票照
    handleUpdateCertImageSubmit(){
      updateBranchInfo(this.siteItem).then((res)=>{
        if(res){
          if(res.data.code===200) {
            this.showCertImageInfo = false;
            this.getSiteUserInfo();
            this.$toast.success(res.data.msg);
          }else{
            this.$toast.fail(res.data.msg);
          }
        }
      });
    },
    // 门 头照
    handleUpdateImgSubmit(){
      if(this.longitude&&this.latitude){
        this.siteItem.longitude = this.longitude;
        this.siteItem.latitude = this.latitude;
        updateBranchInfo(this.siteItem).then((res)=>{
          if(res){
            if(res.data.code===200) {
              this.showImgInfo = false;
              this.getSiteUserInfo();
              this.$toast.success(res.data.msg);
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        });
      }else{
        // this.$toast('未获取到您当前地理位置，请前往系统权限改为允许访问定位！')
        // this.getLocation();
      }
    },
    showModal(type){
      if(type==='updateStationModal'){
        this.showSiteInfo = !this.showSiteInfo;
      }else if(type==='updateOwnerModal'){
        if(this.agentInfo.contact){
          this.showUserInfo = !this.showUserInfo;
        }
      }else if(type==='bankModal'){
        this.showBankInfo = !this.showBankInfo;
      }else if(type==='uploadPhotoModal'){
        this.imgForm2.showVideoPath = this.siteItem.storefrontPhotoUrl;
        this.showImgInfo = !this.showImgInfo;
      }else if(type==='uploadPhoto2Modal'){
        this.imgForm1.showVideoPath = this.siteItem.ticketPhotoUrl;
        this.showImageInfo = !this.showImageInfo;
      }else if(type==='uploadCertModal'){
        this.imgForm3.showVideoPath = this.siteItem.agentCertificateUrl;
        this.showCertImageInfo = !this.showCertImageInfo;
      }

      // else if(type==='addSalesStaffModal'){
      //   this.showAddInfo = !this.showAddInfo;
      // }
    },
    getModel(type){
      if(type==='AddressUpdate'){
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '信息更正');
        console.log(this.siteItem.branchId)
        if(titleNameObj){
          processFlowinit({
            processDefinitionName: titleNameObj.processDefinitionName,
            processDefinitionId: titleNameObj.processDefinitionId,
            categoryName:titleNameObj.category
          }).then((res)=>{
            if(res){
              if(res.data){
                if(res.data.code===200){
                  this.returnObj = res.data.data;
                  let formDefine = JSON.parse(res.data.data.formDefine);
                  if(formDefine){
                    this.formDefine = formDefine;
                    if(formDefine.fields.length>0){
                      formDefine.fields.map((v)=>{
                        v.id_name = '';
                        if(v.id.indexOf('Name')!==-1){
                          v.id_name = 'name'
                        }else if(v.id.indexOf('phone')!==-1){
                          v.id_name = 'phone'
                        }else if(v.id.indexOf('identity')!==-1){
                          v.id_name = 'identity'
                        }
                        if(v.params.customDesign){
                          if(v.params.customDesign.type==='fileupload'){
                            v.files = [];
                          }
                        }
                      });
                      this.flowNameObj = titleNameObj;
                      this.formFields = formDefine.fields;
                      // this.flagAddressUpdate = true;
                      this.flagTemp = true;
                      this.siteIdObj = this.siteItem;
                      this.flagTemplate = true;
                    }
                  }
                }
              }
            }
          });
        }
      }else if(type==='TypeUpdate'){
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '经营类型变更');
        if(titleNameObj){
          processFlowinit({
            processDefinitionName: titleNameObj.processDefinitionName,
            processDefinitionId: titleNameObj.processDefinitionId,
            categoryName:titleNameObj.category
          }).then((res)=>{
            if(res){
              if(res.data){
                if(res.data.code===200){
                  this.returnObj = res.data.data;
                  let formDefine = JSON.parse(res.data.data.formDefine);
                  if(formDefine) {
                    this.formDefine = formDefine;
                    if(formDefine.fields.length>0){
                      formDefine.fields.map((v)=>{
                        v.id_name = '';
                        if(v.id.indexOf('Name')!==-1){
                          v.id_name = 'name'
                        }else if(v.id.indexOf('phone')!==-1){
                          v.id_name = 'phone'
                        }else if(v.id.indexOf('identity')!==-1){
                          v.id_name = 'identity'
                        }
                        if(v.params.customDesign){
                          if(v.params.customDesign.type==='fileupload'){
                            v.files = [];
                          }
                        }
                      });
                      this.flowNameObj = titleNameObj;
                      this.formFields = formDefine.fields;
                      // this.flagTypeUpdate = true;
                      this.flagTemp = true;
                      this.siteIdObj = this.siteItem;
                      this.flagTemplate = true;
                    }
                  }
                }
              }
            }
          });
        }

      }
    },

    getTempReturn(data){
      console.log(data)
      this.flagTemplate = false;
      this.flagTemp = false;
      this.returnObj = {};
    },
    getFlowList(){
      processFlowlist({}).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              // 返回数据
              // category : '西藏-多租户'
              // msgs : [
              // {
              // category:"http://www.flowable.org/processdef"
              // processDefinitionId:"zgy-dxzbg:1:deab1835-42af-11f0-b32c-3606515d593d"
              // processDefinitionName:"专管员-代销者变更"
              // version:"1"
              // }
              // ]
              res.data.data.msgs.map((v)=>{
                if(v.processDefinitionName){
                  if(v.processDefinitionName.split('-')&&v.processDefinitionName.split('-').length>1){
                    v.arr_name = v.processDefinitionName.split('-')[1]
                  }else{
                    v.arr_name = v.processDefinitionName;
                  }
                }
              });
              this.categoryStr = res.data.data.category;
              this.listPramsObj = res.data.data.msgs;
            }
          }
        }
      });
    }
  },
  mounted() {
    this.detectOS();
    this.getFlowList();
  },
  created(){
    this.osIng = this.detectOS();
    console.log('1181',this.osIng)
    if(this.osIng!=='Android'){
      this.initWechatBackListener();
    }
    this.$nextTick(()=> {
      // 门头
      let uploadId2 = document.getElementById('upload_Id2')
      uploadId2.children[0].children[1].setAttribute('capture','camera');
      // 彩票
      let uploadId1 = document.getElementById('upload_Id')
      uploadId1.children[0].children[1].setAttribute('capture','camera');
      // 代销证
      let uploadId3 = document.getElementById('upload_Id3')
      uploadId3.children[0].children[1].setAttribute('capture','camera');
      if (this.$route.query.sid) {
        this.siteId = this.$route.query.sid;
      }
      if (getLocalItem('local_role')) {
        this.roleName = getLocalItem(('local_role'));
        if (getLocalItem('local_role') === '销售员') {
          this.saleInfo();
        } else if (getLocalItem('local_role') === '代销者') {
          this.getSiteUserInfo();
        }
      } else {
        this.roleName = getLocalItem(('roles'));
        if (getLocalItem('roles') === '销售员') {
          this.saleInfo();
        } else if (getLocalItem('roles') === '代销者') {
          this.getSiteUserInfo();
        }
      }
    });
  }
}
</script>

<template>
  <!-- 网点信息页面 -->
  <div id="stationInfoPage" class="">
    <Temp v-model="flagTemp" v-if="flagTemplate" content="del" :variablesObj="{}" :historyList="[]" :flowNameObj="flowNameObj" :siteIdObj.sync="siteIdObj" :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields" @submit="getTempReturn"></Temp>
    <!--    门头照-->
    <div class="wrap-diag" v-show="showImgInfo">
      <div class="modal-container-diag">
        <div class="modal-title">上传门头照片<van-icon name="cross" @click="showImgInfo=!showImgInfo" class="prefix-right" /></div>
        <div class="group-video">
          <div class="group-video-load" >
            <el-upload
                id="upload_Id2"
                class="avatar-uploader"
                :action="fileVideoUrl"
                :headers="headers"
                v-model="imgForm2.showVideoPath"
                accept="image/jpeg, image/jpg, image/png"
                v-bind:on-progress="uploadImgProcess2"
                v-bind:on-success="handleImgSuccess2"
                v-bind:before-upload="beforeUploadImg2"
                v-bind:show-file-list="false"
                capture="camera"
            >
              <div v-if="(imgForm2.showVideoPath !== null) && !imgFlag2" v-bind:src="imgForm2.showVideoPath" class="avatar video-avatar" controls="controls">
                <img :src="imgForm2.showVideoPath" alt="" />
              </div>
              <div class="group-load-item" v-else-if="(imgForm2.showVideoPath===null) && !imgFlag2" >
                <div class="video-icon-img"><i class="el-icon-camera"></i></div>
                <div class="video-icon-txt">拍照上传</div>
              </div>
              <el-progress v-if="imgFlag2 === true" type="circle" v-bind:percentage="imgUploadPercent2" style="text-align: center;"></el-progress>
            </el-upload>
            <div v-if="(imgForm2.showVideoPath !== null) && !imgFlag2" class="aod" @click="beforeDelete(2)">&times;</div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="showImgInfo=!showImgInfo">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit" @click="handleUpdateImgSubmit">提交</van-button>
        </div>
      </div>
    </div>
    <!--    彩票照-->
    <div class="wrap-diag" v-show="showImageInfo">
      <div class="modal-container-diag">
        <div class="modal-title">上传彩票照片<van-icon name="cross" @click="showImageInfo=!showImageInfo" class="prefix-right" /></div>
        <div style="color: red">请拍摄任意一种电脑票的照片上传。比如：双色球、快乐8、福彩3D、七乐彩。</div>
        <div class="group-video">
          <div class="group-video-load" >
            <el-upload
                id="upload_Id"
                class="avatar-uploader"
                :action="fileVideoUrl"
                :headers="headers"
                v-model="imgForm1.showVideoPath"
                accept="image/jpeg, image/jpg, image/png"
                v-bind:on-progress="uploadImgProcess1"
                v-bind:on-success="handleImgSuccess1"
                v-bind:before-upload="beforeUploadImg1"
                v-bind:show-file-list="false"
                capture="camera"
            >
              <div v-if="imgForm1.showVideoPath !== null && !imgFlag1" v-bind:src="imgForm1.showVideoPath" class="avatar video-avatar" controls="controls">
                <img :src="imgForm1.showVideoPath" alt="" />
              </div>
              <div class="group-load-item" v-else-if="imgForm1.showVideoPath === null && !imgFlag1" >
                <div class="video-icon-img"><i class="el-icon-camera"></i></div>
                <div class="video-icon-txt">拍照上传</div>
              </div>
              <el-progress v-if="imgFlag1 === true" type="circle" v-bind:percentage="imgUploadPercent1" style="text-align: center;"></el-progress>
            </el-upload>
            <div v-if="imgForm1.showVideoPath !== null && !imgFlag1" class="aod" @click="beforeDelete(1)">&times;</div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="showImageInfo=!showImageInfo">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit" @click="handleUpdateImageSubmit">提交</van-button>
        </div>
      </div>
    </div>
    <!--    代销证照片-->
    <div class="wrap-diag" v-show="showCertImageInfo">
      <div class="modal-container-diag">
        <div class="modal-title">上传代销证照片<van-icon name="cross" @click="showCertImageInfo=!showCertImageInfo" class="prefix-right" /></div>
        <div class="group-video">
          <div class="group-video-load" >
            <el-upload
                id="upload_Id3"
                class="avatar-uploader"
                :action="fileVideoUrl"
                :headers="headers"
                v-model="imgForm3.showVideoPath"
                accept="image/jpeg, image/jpg, image/png"
                v-bind:on-progress="uploadImgProcess3"
                v-bind:on-success="handleImgSuccess3"
                v-bind:before-upload="beforeUploadImg3"
                v-bind:show-file-list="false"
                capture="camera"
            >
              <div v-if="imgForm3.showVideoPath !== null && !imgFlag3" v-bind:src="imgForm3.showVideoPath" class="avatar video-avatar" controls="controls">
                <img :src="imgForm3.showVideoPath" alt="" />
              </div>
              <div class="group-load-item" v-else-if="imgForm3.showVideoPath === null && !imgFlag3" >
                <div class="video-icon-img"><i class="el-icon-camera"></i></div>
                <div class="video-icon-txt">拍照上传</div>
              </div>
              <el-progress v-if="imgFlag3 === true" type="circle" v-bind:percentage="imgUploadPercent3" style="text-align: center;"></el-progress>
            </el-upload>
            <div v-if="imgForm3.showVideoPath !== null && !imgFlag3" class="aod" @click="beforeDelete(3)">&times;</div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="showCertImageInfo=!showCertImageInfo">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit" @click="handleUpdateCertImageSubmit">提交</van-button>
        </div>
      </div>
    </div>
    <div v-show="chockFlag">
      <!--    html-->
      <div class="content">
        <div class="card">
          <div class="card-title">网点基本信息</div>
          <div class="card-info">
            <div class="info-label">营业状态</div>
            <div class="info-value">{{siteItem.businessStatus?(siteItem.businessStatus===1?'正常营业':'暂停营业'):''}}</div>
          </div>
          <div class="card-info">
            <div class="info-label">网点编号</div>
            <div class="info-value">{{ siteItem.branchId }}</div>
          </div>
          <div class="card-info">
            <div class="info-label">经营类型</div>
            <div class="info-value val-btn">
              {{siteItem.businessType?(siteItem.businessType==='1'?'专营店':'兼营店'):''}}
              <span class="btn btn-primary pd" v-show="roleName==='代销者'" @click="getModel('TypeUpdate')">变更信息</span>
            </div>
          </div>
          <div class="card-info">
            <div class="info-label">所在地区</div>
            <div class="info-value">
              {{ siteItem.province }}{{siteItem.province&&siteItem.city?'/':''}}{{ siteItem.city }}{{siteItem.city&&siteItem.district?'/':''}}{{ siteItem.district }}
            </div>
          </div>
          <div class="card-info">
            <div class="info-label">详细地址</div>
            <div class="info-value val-btn">
              {{ siteItem.address }}
<!--              <span class="btn btn-primary pd" v-show="roleName==='代销者'" @click="getModel('AddressUpdate')">变更信息</span>-->
            </div>
          </div>
          <div class="divider"></div>
          <!--          <div class="card-actions" v-show="roleName==='代销者'">-->
          <!--            <button class="btn btn-primary" @click="showModal('updateStationModal')">修改</button>-->
          <!--          </div>-->
        </div>
        <!-- 无银行卡 -->
        <div class="card" v-if="!agentInfo.bankCardNumber&&roleName==='代销者'">
          <div class="card-title">银行卡信息</div>
          <div class="card-bong">
            <div class="card-bong-icon">🏦</div>
            <div>您还未填写银行卡信息</div>
          </div>
          <button class="btn btn-primary" style="width: 100%;" @click="showModal('bankModal')">去填写银行卡</button>
        </div>
        <!-- 有银行卡 -->
        <div class="card" v-if="agentInfo.bankCardNumber&&agentInfo.bankName">
          <div class="card-title">
            银行卡信息
            <button class="btn btn-outline" @click="showModal('bankModal')" v-show="roleName==='代销者'">修改</button>
          </div>
          <div id="bankAccountContainer">
            <!-- 当有账户时显示 -->
            <div id="hasBankAccount">
              <div class="card-info">
                <div class="info-label">开户银行</div>
                <div class="info-value" id="bankName">{{ agentInfo.bankName }}</div>
              </div>
              <div class="card-info">
                <div class="info-label">开户支行</div>
                <div class="info-value" id="branchName">{{agentInfo.bankBranch}}</div>
              </div>
              <div class="card-info">
                <div class="info-label">开户名</div>
                <div class="info-value" id="accountName">{{ agentInfo.agentName }}</div>
              </div>
              <div class="card-info">
                <div class="info-label">银行卡号</div>
                <div class="info-value" id="accountNumber">{{agentInfo.bankCardNumber|idCardHideValue}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-show="roleName==='代销者'">
          <div class="card-title">代销者信息</div>
          <div class="card-info">
            <div class="info-label">姓名</div>
            <div class="info-value">{{ agentInfo.agentName }}</div>
          </div>
          <div class="card-info">
            <div class="info-label">身份证号</div>
            <div class="info-value">{{ agentInfo.idCard|idCardHideValue}}</div>
          </div>
          <div class="card-info">
            <div class="info-label">手机号码</div>
            <div class="info-value">{{ agentInfo.contact|phoneHideValue }}</div>
          </div>
          <div class="divider"></div>
          <div class="card-actions" v-show="roleName==='代销者'">
            <button class="btn btn-primary" @click="showModal('updateOwnerModal')">修改</button>
          </div>
        </div>
        <!-- 新增：销售员信息 -->
        <div class="card" >
          <div class="card-title">销售员信息</div>
          <div id="salesStaffList" class="staff-list" v-if="salespersonInfos.length>0&&roleName==='代销者'">
            <div class="staff-item" v-for="(item,index) in salespersonInfos" :key="index">
              <div class="staff-info">
                <div class="staff-name">{{ item.name }} <span class="status-tag tag-pending" v-show="item.reviewStatus===0">待审核</span></div>
                <div class="staff-phone">
                  <span>{{item.gender==='0'?'男':'女'}} | {{item.age}}岁</span>
                  <span style="margin-left: 10px;">电话：{{ item.contact|phoneHideValue }}</span>
                </div>
              </div>
              <button class="btn btn-outline pd" v-if="item.reviewStatus===1" @click="confirmDeleteStaff(item,3)">删除</button>
              <div class="btn-gap" v-else>
                <button class="btn btn-primary pd" @click="getStaff(item,1)">通过</button>
                <button class="btn btn-outline pd" @click="getStaff(item,2)">拒绝</button>
              </div>
            </div>
          </div>
          <div v-if="salespersonInfos.length===0&&roleName==='代销者'">
            <div class="card-bong">
              <div>暂无销售员</div>
            </div>
          </div>
          <!--          销售员信息-->
          <div class="card-info" v-show="roleName==='销售员'">
            <div class="info-label">姓名</div>
            <div class="info-value">{{ salesObj.name }}</div>
          </div>
          <div class="card-info" v-show="roleName==='销售员'">
            <div class="info-label">年龄</div>
            <div class="info-value">{{ salesObj.age}}</div>
          </div>
          <div class="card-info" v-show="roleName==='销售员'">
            <div class="info-label">性别</div>
            <div class="info-value">{{ salesObj.gender?(salesObj.gender==='0'?'男':'女'):''}}</div>
          </div>
          <div class="card-info" v-show="roleName==='销售员'">
            <div class="info-label">手机号码</div>
            <div class="info-value">{{ salesObj.contact|phoneHideValue }}</div>
          </div>
        </div>

        <!--        门头照片-->
        <div class="card">
          <div class="card-title">门头照片</div>
          <div class="preview-grid" v-if="siteItem&&siteItem.storefrontPhotoUrl">
            <div class="preview-item">
              <img :src="siteItem.storefrontPhotoUrl" alt="门头照片" />
            </div>
          </div>
          <!--          <div class="preview-grid" v-show="!siteItem.storefrontPhotoUrl">-->
          <!--            <div class="preview-item"><van-icon name="photo-o" /></div>-->
          <!--          </div>-->
          <div v-if="!siteItem.storefrontPhotoUrl">
            <div class="card-bong">
              <div>{{roleName==='代销者'?'您还未上传门头照片':'暂无门头照片'}}</div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="card-actions">
            <button class="btn " :class="!siteItem.storefrontPhotoUrl?'btn-primary':'pink-color'" @click="showModal('uploadPhotoModal')">{{!siteItem.storefrontPhotoUrl?'去上传':'重新上传'}}</button>
          </div>
        </div>
        <!--        彩票照片-->
        <div class="card">
          <div class="card-title">彩票照片</div>
          <div class="preview-grid" v-if="siteItem&&siteItem.ticketPhotoUrl">
            <div class="preview-item">
              <img :src="siteItem.ticketPhotoUrl" alt="彩票照片" />
            </div>
          </div>
          <div v-if="!siteItem.ticketPhotoUrl">
            <div class="card-bong">
              <div>{{roleName==='代销者'?'您还未上传彩票照片':'暂无彩票照片'}}</div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="card-actions">
            <button class="btn " :class="!siteItem.ticketPhotoUrl?'btn-primary':'pink-color'" @click="showModal('uploadPhoto2Modal')">{{!siteItem.ticketPhotoUrl?'去上传':'重新上传'}}</button>
          </div>
        </div>
        <!--        代销证-->
        <div class="card">
          <div class="card-title">代销证照片</div>
          <div class="preview-grid" v-if="siteItem&&siteItem.agentCertificateUrl">
            <div class="preview-item">
              <img :src="siteItem.agentCertificateUrl" alt="代销证照片" />
            </div>
          </div>
          <div v-if="!siteItem.agentCertificateUrl">
            <div class="card-bong">
              <div>{{roleName==='代销者'?'您还未上传代销证照片':'暂无代销证照片'}}</div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="card-actions">
            <button class="btn " :class="!siteItem.agentCertificateUrl?'btn-primary':'pink-color'" @click="showModal('uploadCertModal')">{{!siteItem.agentCertificateUrl?'去上传':'重新上传'}}</button>
          </div>
        </div>
      </div>
      <!--  model-->
      <!--    网点信息-->
      <site-info-modal v-model="showSiteInfo" :siteItem="siteItem" @submit="handleSiteInfoSubmit" />
      <!--    代销者信息-->
      <user-info-modal v-model="showUserInfo" :agentInfo="agentInfo" :branchId="siteId" @submit="handleUserInfoSubmit" />
      <!--    增加销售员信息-->
      <!--      <add-info-modal v-model="showAddInfo" @submit="handleAddUserInfoSubmit" />-->
      <!--    银行信息-->
      <add-bank-modal v-model="showBankInfo" :agentInfo="agentInfo" @submit="handleAddBackInfoSubmit" />
      <!--    修改门头照-->
      <!--      <update-img-modal v-model="showImgInfo" :siteItem="siteItem" @submit="handleUpdateImgSubmit" />-->

    </div>
    <div class="loading" v-show="!chockFlag">
      <van-loading size="25px" type="spinner" text-size="15px" color="#e62d2d">加载中...</van-loading>
    </div>
  </div>
</template>

<style scoped lang="scss">
//.content{
//  padding-top: 120px;
//  box-sizing: border-box;
//}
.retry-dialog{

  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.8);
  padding: 0 10%;

  .inner {
    position: absolute;
    left: 50%;
    top: 20%;
    z-index: 4;
    transform: translate(-50%, -20%);
    width: 80%;
    height:25%;
    background: white;
    border-radius: 20px;
    text-align: center;
    h2{
      padding-top: 60px;
      font-size: 32px;
    }
    p{
      line-height: 120px;
    }
    button{
      border: none;
      outline: none;
      padding: 20px 60px;
      background: #2196f3;
      color: white;
      border-radius: 10px;
    }
  }
}
.wrap-diag{
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  background: rgba(0,0,0,0.3);
  .modal-container-diag{
    background: white;
    height: auto;
    width: 100vw;
    position: fixed;
    left: 0;
    bottom: 0;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    padding: 20px;
    .prefix-right{
      position: absolute;
      right: 40px;
      top: 40px;
      font-size: 44px;
      color: #8f8f8f;
    }
  }
}
.loading{
  height:100vh;
  width:100vw;
  position: relative;
  .van-loading{
    position: absolute;
    top:10%;
    left:50%;
    transform: translate(-50%,-10%);
    text-align: center;
  }
}

.group-video{
  border: 1px dashed #afafaf;
  border-radius: 10px;
  height: 37vw;
  width: 37vw;
  margin-top: 20px;
  position: relative;
  .group-video-load{
    position: relative;
    border-radius: 10px;
    height:100%;
    width:100%;
    border:1px dashed #e9e9e9;
    overflow: hidden;
    .avatar-uploader{
      display: flex;
      width:100%;
      height:100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      .el-upload{
        width:100%;
        height:100%;
        .avatar{
          width:100%;
          height:100%;
          img{
            width:100%;
            height:100%;
          }
        }
      }
    }
    .group-load-item{
      position: absolute;
      top:50%;
      left:50%;
      z-index:1;
      transform:translate(-50%,-50%);
      border-radius:10px;
      padding:70px 0;
      text-align: center;
      width:100%;
      height:100%;
      font-size: 28px;
      .video-icon-img{
        width: 80px;
        height: 50px;
        margin: 0 auto;
        font-size: 60px;
        color: #ababab;
        img{
          width: 80px;
          height: 50px;
        }
      }
      .video-icon-txt{
        color: #ababab;
        padding-top: 20px;
      }
    }
    .aod{
      position: absolute;
      right: 0;
      top:0;
      z-index: 10000;
      color: #fff;
      font-size: 30px;
      height: 44px;
      line-height: 44px;
      width: 44px;
      text-align: center;
      background: #222;
      border-radius: 0 12px 0 0.32rem;
    }
  }
}
</style>